import {PlayerColor} from '@colonist/game-states'
import {RankedDivisionTypes, RankedSubDivisionTypes} from '@colonist/leaderboard-types'
import {ImageURL, LobbyImage} from '@colonist/types'

import IconPencil from '@static/images/icon_pencil.svg'
import IconBot from '@static/images/icon_bot.svg'
import IconBotBeginner from '@static/images/icon_bots_beginner.svg'
import IconBotEasy from '@static/images/icon_bots_easy.svg'
import IconBotMedium from '@static/images/icon_bots_medium.svg'
import IconBotHard from '@static/images/icon_bots_hard.svg'
import IconCheckMark from '@static/images/icon_check.svg'
import IconXMark from '@static/images/icon_x.svg'
import IconLogo from '@static/images/logo.png'
import IconLightning from '@static/images/icon_lightning.svg'
import IconPlus from '@static/images/icon_plus.svg'
import IconPlusStore from '@static/images/icon_plus_store.svg'
import IconMail from '@static/images/icon_mail.svg'
import IconAdmin from '@static/images/icon_admin.svg'
import IconModerator from '@static/images/icon_moderator.svg'
import IconUser from '@static/images/icon_player_loggedin.svg'
import IconGuest from '@static/images/icon_player.svg'
import IconStar from '@static/images/icon_star.svg'
import IconPlayers from '@static/images/icon_players.svg'
import IconReplayIcon from '@static/images/icon_replay.svg'
import IconQuestionMark from '@static/images/icon_question_mark.svg'
import IconInfoIcon from '@static/images/icon_info.svg'
import IconDangerIcon from '@static/images/icon_danger.svg'
import IconKarmaWhite from '@static/images/karma_white.svg'
import IconKarmaRed from '@static/images/karma_red.svg'
import IconKarmaOrange from '@static/images/karma_orange.svg'
import IconKarmaGreen from '@static/images/karma_green.svg'
import IconDisableAdBlock from '@static/images/disable_abblock.png'
import IconColonistCoin from '@static/images/icon_colonist_coin.svg'
import IconRulebook from '@static/images/icon_book.svg'
import IconBankIcon from '@static/images/icon_bank.svg'
import IconFullScreenExpand from '@static/images/icon_fullscreen_expand.svg'
import IconFullScreenContract from '@static/images/icon_fullscreen_contract.svg'
import IconFullScreenGif from '@static/images/gif_fullscreen.gif'
import IconLeftArrow from '@static/images/icon_arrow.svg'
import IconAudio from '@static/images/icon_audio.svg'
import IconEye from '@static/images/icon_eye.svg'
import IconSendArrow from '@static/images/icon_send.svg'
import IconSettings from '@static/images/icon_settings.svg'
import IconChat from '@static/images/icon_chat.svg'
import IconLog from '@static/images/icon_log.svg'
import IconMatchmakingSearch from '@static/images/icon_mm_search.svg'
import IconLock from '@static/images/icon_lock.svg'
import IconLockOutlined from '@static/images/icon_lock_outlined.svg'
import IconLockSlanted from '@static/images/icon_lock_slanted.svg'
import IconShare from '@static/images/icon_share.svg'
import IconNoAds from '@static/images/icon_no_ads.svg'
import IconColors from '@static/images/icon_colors.svg'
import IconAvatars from '@static/images/store_icon_avatar.png'
import IconMaps from '@static/images/store_icon_maps.png'
import IconExpansions from '@static/images/store_icon_expansions.png'
import IconAllColors from '@static/images/store_icon_colors.png'

import IconMapDiamondPreview from '@static/images/map_diamond_preview.png'
import IconMapIstanbulPreview from '@static/images/map_istanbul_preview.png'
import IconMapLakesPreview from '@static/images/map_lakes_preview.png'
import IconMapPondPreview from '@static/images/map_pond_preview.png'
import IconMapGearPreview from '@static/images/map_gear_preview.png'
import IconMapUSAPreview from '@static/images/map_usa_preview.png'
import IconMapTwirlPreview from '@static/images/map_twirl_preview.png'
import IconMapEarthPreview from '@static/images/map_earth_preview.png'
import IconMapUKPreview from '@static/images/map_uk_preview.png'
import IconMapShuffleBoardPreview from '@static/images/map_shuffleboard_preview.png'
import IconMapPangaeaPreview from '@static/images/map_pangaea_preview.png'
import IconMapSpinnerPreview from '@static/images/map_spinner_preview.png'
import IconMapCyclopsPreview from '@static/images/map_cyclops_preview.png'
import IconMapRandomBasePreview from '@static/images/map_random_base_preview.png'
import IconMapClassic4PPreview from '@static/images/map_base_4p_preview.png'
import IconMapRomaniaPreview from '@static/images/map_romania_preview.png'
import IconMapHourglassPreview from '@static/images/map_hourglass_preview.png'
import IconMapHourglassXLPreview from '@static/images/map_hourglass_xl_preview.png'
import IconMapSnowflakePreview from '@static/images/map_snowflake_preview.png'
import IconMapMiniBasePreview from '@static/images/map_mini_base_preview.png'
import IconMapAustraliaPreview from '@static/images/map_australia_preview.png'
import IconMapCirclePreview from '@static/images/map_circle_preview.png'
import IconMapDuelPreview from '@static/images/map_duel_preview.png'
import IconMapMonopolyPreview from '@static/images/map_monopoly_preview.png'
import IconMapKingOfTheHillPreview from '@static/images/map_king_of_the_hill_preview.png'
import IconMapEuropePreview from '@static/images/map_europe_preview.png'

import IconMapMountainOfRichesPreview from '@static/images/map_mountain_of_riches_preview.png'
import IconMapDoggoPreview from '@static/images/map_doggo_preview.png'
import IconMapTradeIslandsPreview from '@static/images/map_trade_islands_preview.png'
import IconMapTurningTidesPreview from '@static/images/map_turning_tides_preview.png'
import IconMapBlackForestPreview from '@static/images/map_blackforest_preview.png'
import IconMapVolcanoPreview from '@static/images/map_volcano_preview.png'
import IconMapKitePreview from '@static/images/map_kite_preview.png'
import IconMapVietnamPreview from '@static/images/map_vietnam_preview.png'
import IconMapTwoIslesPreview from '@static/images/map_two_isles_preview.png'
import IconMapJellyFishPreview from '@static/images/map_jellyfish_preview.png'
import IconMapGoldRushPreview from '@static/images/map_goldrush_preview.png'
import IconMapStripesPreview from '@static/images/map_stripes_preview.png'
import IconMapMonopolyIslandsPreview from '@static/images/map_monopoly_islands_preview.png'

import IconMapClassic56PPreview from '@static/images/map_5_6_player_preview.png'
import IconMapClassic78PPreview from '@static/images/map_7_8_player_preview.png'

import IconMapSS1HeadingForNewShores3PPreview from '@static/images/map_ss1_3p_preview.png'
import IconMapSS1HeadingForNewShores4PPreview from '@static/images/map_ss1_4p_preview.png'
import IconMapSS1HeadingForNewShores56PPreview from '@static/images/map_ss1_6p_preview.png'
import IconMapSS2FourIslands3PPreview from '@static/images/map_ss2_3p_preview.png'
import IconMapSS2FourIslands4PPreview from '@static/images/map_ss2_4p_preview.png'
import IconMapSS2SixIslands56PPreview from '@static/images/map_ss2_6p_preview.png'
import IconMapSS3FogIslands3PPreview from '@static/images/map_ss3_3p_preview.png'
import IconMapSS3FogIslands4PPreview from '@static/images/map_ss3_4p_preview.png'
import IconMapSS3FogIslands56PPreview from '@static/images/map_ss3_6p_preview.png'
import IconMapSS4ThroughTheDesert3PPreview from '@static/images/map_ss4_3p_preview.png'
import IconMapSS4ThroughTheDesert4PPreview from '@static/images/map_ss4_4p_preview.png'
import IconMapSS4ThroughTheDesert56PPreview from '@static/images/map_ss4_6p_preview.png'

import IconGameMode1v1 from '@static/images/icon_gamemode_1v1.svg'
import IconGameModeBase from '@static/images/game_mode_icons/base.svg'
import IconGameModeBase56P from '@static/images/game_mode_icons/56player.svg'
import IconGameModeBase78P from '@static/images/game_mode_icons/78player.svg'
import IconGameModeSeafarers from '@static/images/game_mode_icons/seafarers.svg'
import IconGameModeSeafarers56P from '@static/images/game_mode_icons/seafarers_56player.svg'
import IconGameModeCnK from '@static/images/game_mode_icons/cities_and_knights.svg'
import IconGameModeCitiesAndKnights56P from '@static/images/game_mode_icons/cities_and_knights_56player.svg'
import IconGameModeCnKSeafarers from '@static/images/game_mode_icons/seafarers_cities_and_knights.svg'
import IconGameModeSeafarersCitiesAndKnights56P from '@static/images/game_mode_icons/seafarers_cities_and_knights_56player.svg'
import IconGameModeColonistRush from '@static/images/game_mode_icons/colonist_rush.png'
import IconGameModeShuffle from '@static/images/game_mode_icons/shuffle.svg'
import IconGameModeRanked1v1 from '@static/images/game_mode_icons/1v1_ranked.svg'
import IconGameModeRanked4P from '@static/images/game_mode_icons/4p_ranked.svg'

import IconSettlerPack from '@static/images/pack_settler.svg'
import IconColonistPack from '@static/images/pack_colonist.svg'
import IconFounderPack from '@static/images/pack_founder.svg'

import IconRoadBronze from '@static/images/road_bronze.svg'
import IconSettlementBronze from '@static/images/settlement_bronze.svg'
import IconCityBronze from '@static/images/city_bronze.svg'

import IconBank from '@static/images/bank.svg'
import IconRobber from '@static/images/icon_robber.svg'
import IconDice6 from '@static/images/dice_6.svg'
import IconPrivateGame from '@static/images/icon_sunglasses.svg'
import IconHideBankCards from '@static/images/icon_hide_bank_card.svg'

import IconStoreItemExpansionClassic56P from '@static/images/store/store_item_56player.png'
import IconStoreItemExpansionClassic78P from '@static/images/store/store_item_78player.png'
import IconStoreItemSeafarers4P from '@static/images/store/store_item_seafarers.png'
import IconStoreItemSeafarers56P from '@static/images/store/store_item_seafarers_56player.png'
import IconStoreItemCitiesAndKnights4P from '@static/images/store/store_item_cities_and_knights.png'
import IconStoreItemCitiesAndKnights56P from '@static/images/store/store_item_cities_and_knights_56player.png'
import IconStoreItemCitiesAndKnightsSeafarers4P from '@static/images/store/store_item_seafarers_cities_and_knights.png'
import IconStoreItemCitiesAndKnightsSeafarers56P from '@static/images/store/store_item_seafarers_cities_and_knights_56player.png'

import IconStoreColorBlack from '@static/images/store_color_black.png'
import IconStoreColorPurple from '@static/images/store_color_purple.png'
import IconStoreColorMysticBlue from '@static/images/store_color_mysticblue.png'
import IconStoreColorWhite from '@static/images/store_color_white.png'
import IconStoreColorBronze from '@static/images/store_color_bronze.png'
import IconStoreColorSilver from '@static/images/store_color_silver.png'
import IconStoreColorGold from '@static/images/store_color_gold.png'
import IconStoreColorPink from '@static/images/store_color_pink.png'
import IconStoreMembership from '@static/images/store_icon_membership.svg'

import IconIconSettlerHat from '@static/images/icon_settler.svg'
import IconIconColonistHat from '@static/images/icon_colonist.svg'
import IconIconFounderHat from '@static/images/icon_founder.svg'
import IconIconChristmasHat from '@static/images/icon_christmas_hat.svg'
import IconIconRobberSanta from '@static/images/icon_robber_santa.svg'
import IconIconRobberLunar from '@static/images/icon_robber_lunar.png'
import IconIconRobberCupid from '@static/images/icon_robber_cupid.png'
import IconIconPirateShip from '@static/images/icon_pirate_ship.svg'
import IconIconMedalGold from '@static/images/medal_gold.svg'
import IconIconMedalSilver from '@static/images/medal_silver.svg'
import IconIconMedalBronze from '@static/images/medal_bronze.svg'

import IconIconElephant from '@static/images/icon_elephant.svg'
import IconIconSombrero from '@static/images/icon_sombrero.svg'
import IconIconFarmer from '@static/images/icon_farmer.svg'
import IconIconAvocado from '@static/images/icon_avocado.svg'
import IconIconCactus from '@static/images/icon_cactus.svg'
import IconIconCrown from '@static/images/icon_crown.svg'
import IconIconSwords from '@static/images/icon_swords.svg'
import IconIconHelmet from '@static/images/icon_helmet.svg'
import IconIconSnorkel from '@static/images/icon_snorkel.svg'
import IconIconScarf from '@static/images/icon_scarf.svg'
import IconIconTie from '@static/images/icon_tie.svg'
import IconIconWorker from '@static/images/icon_worker.svg'
import IconIconMummy from '@static/images/icon_mummy.svg'
import IconIconGifter from '@static/images/icon_gifter.svg'
import IconIconNoTroll from '@static/images/icon_no_troll.svg'
import IconIconRotation from '@static/images/icon_rotation.svg'
import IconIconTimeBomb from '@static/images/icon_time_bomb.svg'
import IconIconBeta from '@static/images/icon_beta.svg'

import IconRoadRed from '@static/images/road_red.svg'
import IconRoadBlue from '@static/images/road_blue.svg'
import IconRoadGreen from '@static/images/road_green.svg'
import IconRoadOrange from '@static/images/road_orange.svg'
import IconRoadBlack from '@static/images/road_black.svg'
import IconRoadSilver from '@static/images/road_silver.svg'
import IconRoadGold from '@static/images/road_gold.svg'
import IconRoadWhite from '@static/images/road_white.svg'
import IconRoadPurple from '@static/images/road_purple.svg'
import IconRoadMysticBlue from '@static/images/road_mysticblue.svg'
import IconRoadPink from '@static/images/road_pink.svg'

import IconSettlementRed from '@static/images/settlement_red.svg'
import IconSettlementBlue from '@static/images/settlement_blue.svg'
import IconSettlementGreen from '@static/images/settlement_green.svg'
import IconSettlementOrange from '@static/images/settlement_orange.svg'
import IconSettlementBlack from '@static/images/settlement_black.svg'
import IconSettlementSilver from '@static/images/settlement_silver.svg'
import IconSettlementGold from '@static/images/settlement_gold.svg'
import IconSettlementWhite from '@static/images/settlement_white.svg'
import IconSettlementPurple from '@static/images/settlement_purple.svg'
import IconSettlementMysticBlue from '@static/images/settlement_mysticblue.svg'
import IconSettlementPink from '@static/images/settlement_pink.svg'

import IconCityRed from '@static/images/city_red.svg'
import IconCityBlue from '@static/images/city_blue.svg'
import IconCityGreen from '@static/images/city_green.svg'
import IconCityOrange from '@static/images/city_orange.svg'
import IconCityBlack from '@static/images/city_black.svg'
import IconCitySilver from '@static/images/city_silver.svg'
import IconCityGold from '@static/images/city_gold.svg'
import IconCityWhite from '@static/images/city_white.svg'
import IconCityPurple from '@static/images/city_purple.svg'
import IconCityMysticBlue from '@static/images/city_mysticblue.svg'
import IconCityPink from '@static/images/city_pink.svg'

import IconStoreMembershipPlus from '@static/images/membership_icon_plus.svg'
import IconStoreMembershipPremium from '@static/images/membership_icon_premium.svg'
import IconStoreMembershipElite from '@static/images/membership_icon_elite.svg'
import IconStoreMembershipHoliday2023 from '@static/images/membership_icon_holiday2023.svg'
import IconStoreGiftMembership from '@static/images/icon_gift_box.svg'
import IconStoreGiftMembershipDark from '@static/images/icon_gift_box_dark.svg'

import IconStoreMembershipPerkAllMaps from '@static/images/perks_icon_free_maps.png'
import IconStoreMembershipPerkAllExpansions from '@static/images/perks_icon_free_expansions.png'
import IconStoreMembershipPerkRankedGames from '@static/images/perks_icon_ranked.png'
import IconStoreMembershipPerkCustomLinks from '@static/images/perks_icon_custom_links.png'
import IconStoreMembershipPerkColonistCoins from '@static/images/perks_icon_coins.png'
import IconStoreMembershipPerkNoAds from '@static/images/perks_icon_no_ads.png'
import IconStoreMembershipPerkNoAdsGifDesertBox from '@static/images/gif_remove_ads_boxedshape_desert.gif'
import IconStoreMembershipPerkNoAdsGifGoldBox from '@static/images/gif_remove_ads_boxedshape_gold.gif'
import IconStoreMembershipPerkNoAdsGifDesertHex from '@static/images/gif_remove_ads_hexedshape_desert.gif'
import IconStoreMembershipPerkNoAdsGifGoldHex from '@static/images/gif_remove_ads_hexedshape_gold.gif'

import IconCoinStack1 from '@static/images/coin_stack_1.png'
import IconCoinStack2 from '@static/images/coin_stack_2.png'
import IconCoinStack3 from '@static/images/coin_stack_3.png'
import IconCoinStack4 from '@static/images/coin_stack_4.png'
import IconCoinStack5 from '@static/images/coin_stack_5.png'
import IconCoinStack6 from '@static/images/coin_stack_6.png'

import IconFriends from '@static/images/icon_profile_friends.svg'
import IconAddFriend from '@static/images/icon_add_friend_2.svg'

import IconGoogleIcon from '@static/images/icon_google.svg'
import IconAppleIcon from '@static/images/icon_apple.svg'
import IconDiscordIcon from '@static/images/icon_discord.svg'
import IconFacebookIcon from '@static/images/icon_facebook.svg'

import IconRankBronze from '@static/images/ranking_divisions/bronze.svg'
import IconRankSilver from '@static/images/ranking_divisions/silver.svg'
import IconRankGold from '@static/images/ranking_divisions/gold.svg'
import IconRankPlatinum from '@static/images/ranking_divisions/platinum.svg'
import IconRankDiamond from '@static/images/ranking_divisions/diamond.svg'
import IconRankMaster from '@static/images/ranking_divisions/master.svg'
import IconRankGrandmaster from '@static/images/ranking_divisions/grandmaster.svg'

import IconRankSubdivisionI from '@static/images/ranking_divisions/subdivisions_i.svg'
import IconRankSubdivisionII from '@static/images/ranking_divisions/subdivisions_ii.svg'
import IconRankSubdivisionIII from '@static/images/ranking_divisions/subdivisions_iii.svg'
import IconRankSubdivisionIV from '@static/images/ranking_divisions/subdivisions_iv.svg'
import IconRankSubdivisionV from '@static/images/ranking_divisions/subdivisions_v.svg'
import IconMenuPortraitMode from '@static/images/menu_portrait_mode.png'
import IconMenuLandscapeMode from '@static/images/menu_landscape_mode.png'

import IconRewindToStart from '@static/images/icon_rewind_start.svg'
import IconRewind from '@static/images/icon_rewind.svg'
import IconPlay from '@static/images/icon_play.svg'
import IconPause from '@static/images/icon_pause.svg'
import IconFastForward from '@static/images/icon_forward.svg'
import IconFastForwardToEnd from '@static/images/icon_forward_end.svg'

import IconX05 from '@static/images/icon_05x.svg'
import IconX1 from '@static/images/icon_1x.svg'
import IconX2 from '@static/images/icon_2x.svg'
import IconX4 from '@static/images/icon_4x.svg'
import IconX8 from '@static/images/icon_8x.svg'

import IconDownArrowBlack from '@static/images/icon_arrow_down_black.svg'
import IconDownArrow from '@static/images/icon_arrow_down.svg'
import IconUpArrow from '@static/images/icon_arrow_up.svg'

import IconLongestRoad from '@static/images/icon_longest_road_highlight.svg'
import IconLargestArmy from '@static/images/icon_largest_army_highlight.svg'
import IconCardMonopoly from '@static/images/card_monopoly.svg'
import IconCardVictoryPoint from '@static/images/card_vp.svg'

import IconProfileOverview from '@static/images/icon_profile_overview.svg'
import IconProfileRanked from '@static/images/icon_profile_ranked.svg'
import IconProfileHistory from '@static/images/icon_profile_history.svg'
import IconProfileItems from '@static/images/icon_profile_items.svg'
import IconProfileMembership from '@static/images/icon_profile_membership.svg'

import IconTournamentCC25 from '@static/images/badge_tournament_cc25.svg'
import IconTournamentS11First from '@static/images/badge_tournament_s11_first.svg'
import IconTournament4P from '@static/images/badge_tournament_4p.svg'

import IconBannerMember from '@static/images/banner_member.png'
import IconBannerShuffle from '@static/images/banner_shuffle.png'

import CityWallRed from '@static/images/city_wall_red.svg'
import CityWallBlue from '@static/images/city_wall_blue.svg'
import CityWallOrange from '@static/images/city_wall_orange.svg'
import CityWallGreen from '@static/images/city_wall_green.svg'
import CityWallBlack from '@static/images/city_wall_black.svg'
import CityWallBronze from '@static/images/city_wall_bronze.svg'
import CityWallSilver from '@static/images/city_wall_silver.svg'
import CityWallGold from '@static/images/city_wall_gold.svg'
import CityWallWhite from '@static/images/city_wall_white.svg'
import CityWallPurple from '@static/images/city_wall_purple.svg'
import CityWallMysticBlue from '@static/images/city_wall_mysticblue.svg'
import CityWallPink from '@static/images/city_wall_pink.svg'
import ShipRedNorthWest from '@static/images/ship_red_north_west.svg'
import ShipBlueNorthWest from '@static/images/ship_blue_north_west.svg'
import ShipOrangeNorthWest from '@static/images/ship_orange_north_west.svg'
import ShipGreenNorthWest from '@static/images/ship_green_north_west.svg'
import ShipBlackNorthWest from '@static/images/ship_black_north_west.svg'
import ShipBronzeNorthWest from '@static/images/ship_bronze_north_west.svg'
import ShipSilverNorthWest from '@static/images/ship_silver_north_west.svg'
import ShipGoldNorthWest from '@static/images/ship_gold_north_west.svg'
import ShipWhiteNorthWest from '@static/images/ship_white_north_west.svg'
import ShipPurpleNorthWest from '@static/images/ship_purple_north_west.svg'
import ShipMysticBlueNorthWest from '@static/images/ship_mysticblue_north_west.svg'
import ShipPinkNorthWest from '@static/images/ship_pink_north_west.svg'
import KnightLevel1InactiveRed from '@static/images/knight_level1_inactive_red.svg'
import KnightLevel1InactiveBlue from '@static/images/knight_level1_inactive_blue.svg'
import KnightLevel1InactiveOrange from '@static/images/knight_level1_inactive_orange.svg'
import KnightLevel1InactiveGreen from '@static/images/knight_level1_inactive_green.svg'
import KnightLevel1InactiveBlack from '@static/images/knight_level1_inactive_black.svg'
import KnightLevel1InactiveBronze from '@static/images/knight_level1_inactive_bronze.svg'
import KnightLevel1InactiveSilver from '@static/images/knight_level1_inactive_silver.svg'
import KnightLevel1InactiveGold from '@static/images/knight_level1_inactive_gold.svg'
import KnightLevel1InactiveWhite from '@static/images/knight_level1_inactive_white.svg'
import KnightLevel1InactivePurple from '@static/images/knight_level1_inactive_purple.svg'
import KnightLevel1InactiveMysticBlue from '@static/images/knight_level1_inactive_mysticblue.svg'
import KnightLevel1InactivePink from '@static/images/knight_level1_inactive_pink.svg'
import KnightLevel1ActiveRed from '@static/images/knight_level1_active_red.svg'
import KnightLevel1ActiveBlue from '@static/images/knight_level1_active_blue.svg'
import KnightLevel1ActiveOrange from '@static/images/knight_level1_active_orange.svg'
import KnightLevel1ActiveGreen from '@static/images/knight_level1_active_green.svg'
import KnightLevel1ActiveBlack from '@static/images/knight_level1_active_black.svg'
import KnightLevel1ActiveBronze from '@static/images/knight_level1_active_bronze.svg'
import KnightLevel1ActiveSilver from '@static/images/knight_level1_active_silver.svg'
import KnightLevel1ActiveGold from '@static/images/knight_level1_active_gold.svg'
import KnightLevel1ActiveWhite from '@static/images/knight_level1_active_white.svg'
import KnightLevel1ActivePurple from '@static/images/knight_level1_active_purple.svg'
import KnightLevel1ActiveMysticBlue from '@static/images/knight_level1_active_mysticblue.svg'
import KnightLevel1ActivePink from '@static/images/knight_level1_active_pink.svg'
import MerchantRed from '@static/images/icon_merchant_red.svg'
import MerchantBlue from '@static/images/icon_merchant_blue.svg'
import MerchantOrange from '@static/images/icon_merchant_orange.svg'
import MerchantGreen from '@static/images/icon_merchant_green.svg'
import MerchantBlack from '@static/images/icon_merchant_black.svg'
import MerchantBronze from '@static/images/icon_merchant_bronze.svg'
import MerchantSilver from '@static/images/icon_merchant_silver.svg'
import MerchantGold from '@static/images/icon_merchant_gold.svg'
import MerchantWhite from '@static/images/icon_merchant_white.svg'
import MerchantPurple from '@static/images/icon_merchant_purple.svg'
import MerchantMysticBlue from '@static/images/icon_merchant_mysticblue.svg'
import MerchantPink from '@static/images/icon_merchant_pink.svg'
import PlayerBGRed from '@static/images/player_bg_red.svg'
import PlayerBGBlue from '@static/images/player_bg_blue.svg'
import PlayerBGOrange from '@static/images/player_bg_orange.svg'
import PlayerBGGreen from '@static/images/player_bg_green.svg'
import PlayerBGBlack from '@static/images/player_bg_black.svg'
import PlayerBGBronze from '@static/images/player_bg_bronze.svg'
import PlayerBGSilver from '@static/images/player_bg_silver.svg'
import PlayerBGGold from '@static/images/player_bg_gold.svg'
import PlayerBGWhite from '@static/images/player_bg_white.svg'
import PlayerBGPurple from '@static/images/player_bg_purple.svg'
import PlayerBGMysticBlue from '@static/images/player_bg_mysticblue.svg'
import PlayerBGPink from '@static/images/player_bg_pink.svg'
import IconLandscapeDeprecationWarning from '@static/images/landscape_deprecation.gif'
import IconLeaderboard from '@static/images/icon_leaderboard.svg'

export class UIImagePathController {
    private static versionNumber: number

    static readonly roadsByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: IconRoadRed,
        [PlayerColor.Blue]: IconRoadBlue,
        [PlayerColor.Orange]: IconRoadOrange,
        [PlayerColor.Green]: IconRoadGreen,
        [PlayerColor.Black]: IconRoadBlack,
        [PlayerColor.Bronze]: IconRoadBronze,
        [PlayerColor.Silver]: IconRoadSilver,
        [PlayerColor.Gold]: IconRoadGold,
        [PlayerColor.White]: IconRoadWhite,
        [PlayerColor.Purple]: IconRoadPurple,
        [PlayerColor.MysticBlue]: IconRoadMysticBlue,
        [PlayerColor.Pink]: IconRoadPink,
    } as const

    static readonly settlementsByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: IconSettlementRed,
        [PlayerColor.Blue]: IconSettlementBlue,
        [PlayerColor.Orange]: IconSettlementOrange,
        [PlayerColor.Green]: IconSettlementGreen,
        [PlayerColor.Black]: IconSettlementBlack,
        [PlayerColor.Bronze]: IconSettlementBronze,
        [PlayerColor.Silver]: IconSettlementSilver,
        [PlayerColor.Gold]: IconSettlementGold,
        [PlayerColor.White]: IconSettlementWhite,
        [PlayerColor.Purple]: IconSettlementPurple,
        [PlayerColor.MysticBlue]: IconSettlementMysticBlue,
        [PlayerColor.Pink]: IconSettlementPink,
    } as const

    static readonly citiesByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: IconCityRed,
        [PlayerColor.Blue]: IconCityBlue,
        [PlayerColor.Orange]: IconCityOrange,
        [PlayerColor.Green]: IconCityGreen,
        [PlayerColor.Black]: IconCityBlack,
        [PlayerColor.Bronze]: IconCityBronze,
        [PlayerColor.Silver]: IconCitySilver,
        [PlayerColor.Gold]: IconCityGold,
        [PlayerColor.White]: IconCityWhite,
        [PlayerColor.Purple]: IconCityPurple,
        [PlayerColor.MysticBlue]: IconCityMysticBlue,
        [PlayerColor.Pink]: IconCityPink,
    } as const

    static readonly cityWallsByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: CityWallRed,
        [PlayerColor.Blue]: CityWallBlue,
        [PlayerColor.Orange]: CityWallOrange,
        [PlayerColor.Green]: CityWallGreen,
        [PlayerColor.Black]: CityWallBlack,
        [PlayerColor.Bronze]: CityWallBronze,
        [PlayerColor.Silver]: CityWallSilver,
        [PlayerColor.Gold]: CityWallGold,
        [PlayerColor.White]: CityWallWhite,
        [PlayerColor.Purple]: CityWallPurple,
        [PlayerColor.MysticBlue]: CityWallMysticBlue,
        [PlayerColor.Pink]: CityWallPink,
    } as const

    static readonly shipsByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: ShipRedNorthWest,
        [PlayerColor.Blue]: ShipBlueNorthWest,
        [PlayerColor.Orange]: ShipOrangeNorthWest,
        [PlayerColor.Green]: ShipGreenNorthWest,
        [PlayerColor.Black]: ShipBlackNorthWest,
        [PlayerColor.Bronze]: ShipBronzeNorthWest,
        [PlayerColor.Silver]: ShipSilverNorthWest,
        [PlayerColor.Gold]: ShipGoldNorthWest,
        [PlayerColor.White]: ShipWhiteNorthWest,
        [PlayerColor.Purple]: ShipPurpleNorthWest,
        [PlayerColor.MysticBlue]: ShipMysticBlueNorthWest,
        [PlayerColor.Pink]: ShipPinkNorthWest,
    } as const

    static readonly knightsInactiveByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: KnightLevel1InactiveRed,
        [PlayerColor.Blue]: KnightLevel1InactiveBlue,
        [PlayerColor.Orange]: KnightLevel1InactiveOrange,
        [PlayerColor.Green]: KnightLevel1InactiveGreen,
        [PlayerColor.Black]: KnightLevel1InactiveBlack,
        [PlayerColor.Bronze]: KnightLevel1InactiveBronze,
        [PlayerColor.Silver]: KnightLevel1InactiveSilver,
        [PlayerColor.Gold]: KnightLevel1InactiveGold,
        [PlayerColor.White]: KnightLevel1InactiveWhite,
        [PlayerColor.Purple]: KnightLevel1InactivePurple,
        [PlayerColor.MysticBlue]: KnightLevel1InactiveMysticBlue,
        [PlayerColor.Pink]: KnightLevel1InactivePink,
    } as const

    static readonly knightsActiveByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: KnightLevel1ActiveRed,
        [PlayerColor.Blue]: KnightLevel1ActiveBlue,
        [PlayerColor.Orange]: KnightLevel1ActiveOrange,
        [PlayerColor.Green]: KnightLevel1ActiveGreen,
        [PlayerColor.Black]: KnightLevel1ActiveBlack,
        [PlayerColor.Bronze]: KnightLevel1ActiveBronze,
        [PlayerColor.Silver]: KnightLevel1ActiveSilver,
        [PlayerColor.Gold]: KnightLevel1ActiveGold,
        [PlayerColor.White]: KnightLevel1ActiveWhite,
        [PlayerColor.Purple]: KnightLevel1ActivePurple,
        [PlayerColor.MysticBlue]: KnightLevel1ActiveMysticBlue,
        [PlayerColor.Pink]: KnightLevel1ActivePink,
    } as const

    static readonly merchantByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: MerchantRed,
        [PlayerColor.Blue]: MerchantBlue,
        [PlayerColor.Orange]: MerchantOrange,
        [PlayerColor.Green]: MerchantGreen,
        [PlayerColor.Black]: MerchantBlack,
        [PlayerColor.Bronze]: MerchantBronze,
        [PlayerColor.Silver]: MerchantSilver,
        [PlayerColor.Gold]: MerchantGold,
        [PlayerColor.White]: MerchantWhite,
        [PlayerColor.Purple]: MerchantPurple,
        [PlayerColor.MysticBlue]: MerchantMysticBlue,
        [PlayerColor.Pink]: MerchantPink,
    } as const

    static readonly playerBackgroundByColor: Record<PlayerColor, ImageURL> = {
        [PlayerColor.None]: '' as ImageURL,
        [PlayerColor.Red]: PlayerBGRed,
        [PlayerColor.Blue]: PlayerBGBlue,
        [PlayerColor.Orange]: PlayerBGOrange,
        [PlayerColor.Green]: PlayerBGGreen,
        [PlayerColor.Black]: PlayerBGBlack,
        [PlayerColor.Bronze]: PlayerBGBronze,
        [PlayerColor.Silver]: PlayerBGSilver,
        [PlayerColor.Gold]: PlayerBGGold,
        [PlayerColor.White]: PlayerBGWhite,
        [PlayerColor.Purple]: PlayerBGPurple,
        [PlayerColor.MysticBlue]: PlayerBGMysticBlue,
        [PlayerColor.Pink]: PlayerBGPink,
    } as const

    static setVersionNumber(versionNumber: number) {
        this.versionNumber = versionNumber
    }

    static getRankedDivisionImage(division: RankedDivisionTypes): LobbyImage {
        switch(division) {
            case RankedDivisionTypes.Bronze: return LobbyImage.RankBronze
            case RankedDivisionTypes.Silver: return LobbyImage.RankSilver
            case RankedDivisionTypes.Gold: return LobbyImage.RankGold
            case RankedDivisionTypes.Platinum: return LobbyImage.RankPlatinum
            case RankedDivisionTypes.Diamond: return LobbyImage.RankDiamond
            case RankedDivisionTypes.Master: return LobbyImage.RankMaster
            case RankedDivisionTypes.Grandmaster: return LobbyImage.RankGrandmaster
            case RankedDivisionTypes.None: return LobbyImage.XMark
        }
    }

    static getRankedSubdivisionImage(subdivision: RankedSubDivisionTypes): LobbyImage | undefined {
        if(subdivision === RankedSubDivisionTypes.None) return

        switch(subdivision) {
            case RankedSubDivisionTypes.I: return LobbyImage.RankSubdivisionI
            case RankedSubDivisionTypes.II: return LobbyImage.RankSubdivisionII
            case RankedSubDivisionTypes.III: return LobbyImage.RankSubdivisionIII
            case RankedSubDivisionTypes.IV: return LobbyImage.RankSubdivisionIV
            case RankedSubDivisionTypes.V: return LobbyImage.RankSubdivisionV
        }
    }

    static getPlayerColorBuildings(color: PlayerColor): {road: LobbyImage, settlement: LobbyImage, city: LobbyImage} {
        switch(color) {
            case PlayerColor.Red: return {road: LobbyImage.RoadRed, settlement: LobbyImage.SettlementRed, city: LobbyImage.CityRed}
            case PlayerColor.Blue: return {road: LobbyImage.RoadBlue, settlement: LobbyImage.SettlementBlue, city: LobbyImage.CityBlue}
            case PlayerColor.Green: return {road: LobbyImage.RoadGreen, settlement: LobbyImage.SettlementGreen, city: LobbyImage.CityGreen}
            case PlayerColor.Orange: return {road: LobbyImage.RoadOrange, settlement: LobbyImage.SettlementOrange, city: LobbyImage.CityOrange}
            case PlayerColor.Black: return {road: LobbyImage.RoadBlack, settlement: LobbyImage.SettlementBlack, city: LobbyImage.CityBlack}
            case PlayerColor.Silver: return {road: LobbyImage.RoadSilver, settlement: LobbyImage.SettlementSilver, city: LobbyImage.CitySilver}
            case PlayerColor.Gold: return {road: LobbyImage.RoadGold, settlement: LobbyImage.SettlementGold, city: LobbyImage.CityGold}
            case PlayerColor.White: return {road: LobbyImage.RoadWhite, settlement: LobbyImage.SettlementWhite, city: LobbyImage.CityWhite}
            case PlayerColor.Purple: return {road: LobbyImage.RoadPurple, settlement: LobbyImage.SettlementPurple, city: LobbyImage.CityPurple}
            case PlayerColor.MysticBlue: return {road: LobbyImage.RoadMysticBlue, settlement: LobbyImage.SettlementMysticBlue, city: LobbyImage.CityMysticBlue}
            case PlayerColor.Bronze: return {road: LobbyImage.RoadBronze, settlement: LobbyImage.SettlementBronze, city: LobbyImage.CityBronze}
            case PlayerColor.Pink: return {road: LobbyImage.RoadPink, settlement: LobbyImage.SettlementPink, city: LobbyImage.CityPink}
            case PlayerColor.None: break
        }

        return {road: LobbyImage.CheckMark, settlement: LobbyImage.CheckMark, city: LobbyImage.CheckMark}
    }

    static getImgPath(img: LobbyImage): ImageURL {
        switch(img) {
            case LobbyImage.Pencil: return IconPencil
            case LobbyImage.Bot: return IconBot
            case LobbyImage.BotBeginner: return IconBotBeginner
            case LobbyImage.BotEasy: return IconBotEasy
            case LobbyImage.BotMedium: return IconBotMedium
            case LobbyImage.BotHard: return IconBotHard
            case LobbyImage.CheckMark: return IconCheckMark
            case LobbyImage.XMark: return IconXMark
            case LobbyImage.Logo: return IconLogo
            case LobbyImage.Lightning: return IconLightning
            case LobbyImage.Plus: return IconPlus
            case LobbyImage.PlusStore: return IconPlusStore
            case LobbyImage.Mail: return IconMail
            case LobbyImage.Admin: return IconAdmin
            case LobbyImage.Moderator: return IconModerator
            case LobbyImage.User: return IconUser
            case LobbyImage.Guest: return IconGuest
            case LobbyImage.Star: return IconStar
            case LobbyImage.Players: return IconPlayers
            case LobbyImage.ReplayIcon: return IconReplayIcon
            case LobbyImage.QuestionMark: return IconQuestionMark
            case LobbyImage.InfoIcon: return IconInfoIcon
            case LobbyImage.DangerIcon: return IconDangerIcon
            case LobbyImage.KarmaWhite: return IconKarmaWhite
            case LobbyImage.KarmaRed: return IconKarmaRed
            case LobbyImage.KarmaOrange: return IconKarmaOrange
            case LobbyImage.KarmaGreen: return IconKarmaGreen
            case LobbyImage.DisableAdBlock: return IconDisableAdBlock
            case LobbyImage.ColonistCoin: return IconColonistCoin
            case LobbyImage.Rulebook: return IconRulebook
            case LobbyImage.BankIcon: return IconBankIcon
            case LobbyImage.FullScreenExpand: return IconFullScreenExpand
            case LobbyImage.FullScreenContract: return IconFullScreenContract
            case LobbyImage.FullScreenGif: return IconFullScreenGif
            case LobbyImage.LeftArrow: return IconLeftArrow
            case LobbyImage.Audio: return IconAudio
            case LobbyImage.Eye: return IconEye
            case LobbyImage.SendArrow: return IconSendArrow
            case LobbyImage.Settings: return IconSettings
            case LobbyImage.Chat: return IconChat
            case LobbyImage.Log: return IconLog
            case LobbyImage.MatchmakingSearch: return IconMatchmakingSearch
            case LobbyImage.Lock: return IconLock
            case LobbyImage.LockOutlined: return IconLockOutlined
            case LobbyImage.LockSlanted: return IconLockSlanted
            case LobbyImage.Share: return IconShare
            case LobbyImage.NoAds: return IconNoAds
            case LobbyImage.Colors: return IconColors
            case LobbyImage.Avatars: return IconAvatars
            case LobbyImage.Maps: return IconMaps
            case LobbyImage.Expansions: return IconExpansions
            case LobbyImage.AllColors: return IconAllColors
            case LobbyImage.Memberships: return IconStoreMembership

            case LobbyImage.MapDiamondPreview: return IconMapDiamondPreview
            case LobbyImage.MapIstanbulPreview: return IconMapIstanbulPreview
            case LobbyImage.MapLakesPreview: return IconMapLakesPreview
            case LobbyImage.MapPondPreview: return IconMapPondPreview
            case LobbyImage.MapGearPreview: return IconMapGearPreview
            case LobbyImage.MapUSAPreview: return IconMapUSAPreview
            case LobbyImage.MapTwirlPreview: return IconMapTwirlPreview
            case LobbyImage.MapEarthPreview: return IconMapEarthPreview
            case LobbyImage.MapUKPreview: return IconMapUKPreview
            case LobbyImage.MapShuffleBoardPreview: return IconMapShuffleBoardPreview
            case LobbyImage.MapPangaeaPreview: return IconMapPangaeaPreview
            case LobbyImage.MapSpinnerPreview: return IconMapSpinnerPreview
            case LobbyImage.MapCyclopsPreview: return IconMapCyclopsPreview
            case LobbyImage.MapRandomBasePreview: return IconMapRandomBasePreview
            case LobbyImage.MapClassic4PPreview: return IconMapClassic4PPreview
            case LobbyImage.MapRomaniaPreview: return IconMapRomaniaPreview
            case LobbyImage.MapHourglassPreview: return IconMapHourglassPreview
            case LobbyImage.MapHourglassXLPreview: return IconMapHourglassXLPreview
            case LobbyImage.MapSnowflakePreview: return IconMapSnowflakePreview
            case LobbyImage.MapMiniBasePreview: return IconMapMiniBasePreview
            case LobbyImage.MapAustraliaPreview: return IconMapAustraliaPreview
            case LobbyImage.MapCirclePreview: return IconMapCirclePreview
            case LobbyImage.MapDuelPreview: return IconMapDuelPreview
            case LobbyImage.MapMonopolyPreview: return IconMapMonopolyPreview
            case LobbyImage.MapKingOfTheHillPreview: return IconMapKingOfTheHillPreview
            case LobbyImage.MapEuropePreview: return IconMapEuropePreview

            case LobbyImage.MapMountainOfRichesPreview: return IconMapMountainOfRichesPreview
            case LobbyImage.MapDoggoPreview: return IconMapDoggoPreview
            case LobbyImage.MapTradeIslandsPreview: return IconMapTradeIslandsPreview
            case LobbyImage.MapTurningTidesPreview: return IconMapTurningTidesPreview
            case LobbyImage.MapBlackForestPreview: return IconMapBlackForestPreview
            case LobbyImage.MapVolcanoPreview: return IconMapVolcanoPreview
            case LobbyImage.MapKitePreview: return IconMapKitePreview
            case LobbyImage.MapVietnamPreview: return IconMapVietnamPreview
            case LobbyImage.MapTwoIslesPreview: return IconMapTwoIslesPreview
            case LobbyImage.MapJellyFishPreview: return IconMapJellyFishPreview
            case LobbyImage.MapGoldRushPreview: return IconMapGoldRushPreview
            case LobbyImage.MapStripesPreview: return IconMapStripesPreview
            case LobbyImage.MapMonopolyIslandsPreview: return IconMapMonopolyIslandsPreview

            case LobbyImage.MapClassic56PPreview: return IconMapClassic56PPreview
            case LobbyImage.MapClassic78PPreview: return IconMapClassic78PPreview

            case LobbyImage.MapSS1HeadingForNewShores3PPreview: return IconMapSS1HeadingForNewShores3PPreview
            case LobbyImage.MapSS1HeadingForNewShores4PPreview: return IconMapSS1HeadingForNewShores4PPreview
            case LobbyImage.MapSS1HeadingForNewShores56PPreview: return IconMapSS1HeadingForNewShores56PPreview
            case LobbyImage.MapSS2FourIslands3PPreview: return IconMapSS2FourIslands3PPreview
            case LobbyImage.MapSS2FourIslands4PPreview: return IconMapSS2FourIslands4PPreview
            case LobbyImage.MapSS2SixIslands56PPreview: return IconMapSS2SixIslands56PPreview
            case LobbyImage.MapSS3FogIslands3PPreview: return IconMapSS3FogIslands3PPreview
            case LobbyImage.MapSS3FogIslands4PPreview: return IconMapSS3FogIslands4PPreview
            case LobbyImage.MapSS3FogIslands56PPreview: return IconMapSS3FogIslands56PPreview
            case LobbyImage.MapSS4ThroughTheDesert3PPreview: return IconMapSS4ThroughTheDesert3PPreview
            case LobbyImage.MapSS4ThroughTheDesert4PPreview: return IconMapSS4ThroughTheDesert4PPreview
            case LobbyImage.MapSS4ThroughTheDesert56PPreview: return IconMapSS4ThroughTheDesert56PPreview

            case LobbyImage.GameMode1v1: return IconGameMode1v1
            case LobbyImage.GameModeBase: return IconGameModeBase
            case LobbyImage.GameModeBasePreview: return IconGameModeBase
            case LobbyImage.GameModeBase56P: return IconGameModeBase56P
            case LobbyImage.GameModeBase78P: return IconGameModeBase78P
            case LobbyImage.GameModeSeafarers: return IconGameModeSeafarers
            case LobbyImage.GameModeSeafarers56P: return IconGameModeSeafarers56P
            case LobbyImage.GameModeCnK: return IconGameModeCnK
            case LobbyImage.GameModeCitiesAndKnights56P: return IconGameModeCitiesAndKnights56P
            case LobbyImage.GameModeCnKSeafarers: return IconGameModeCnKSeafarers
            case LobbyImage.GameModeSeafarersCitiesAndKnights56P: return IconGameModeSeafarersCitiesAndKnights56P
            case LobbyImage.GameModeColonistRush: return IconGameModeColonistRush
            case LobbyImage.GameModeShuffle: return IconGameModeShuffle
            case LobbyImage.GameModeRanked1v1: return IconGameModeRanked1v1
            case LobbyImage.GameModeRanked4P: return IconGameModeRanked4P

            case LobbyImage.SettlerPack: return IconSettlerPack
            case LobbyImage.ColonistPack: return IconColonistPack
            case LobbyImage.FounderPack: return IconFounderPack

            case LobbyImage.RoadBronze: return IconRoadBronze
            case LobbyImage.SettlementBronze: return IconSettlementBronze
            case LobbyImage.CityBronze: return IconCityBronze

            case LobbyImage.Bank: return IconBank
            case LobbyImage.Robber: return IconRobber
            case LobbyImage.Dice6: return IconDice6
            case LobbyImage.PrivateGame: return IconPrivateGame
            case LobbyImage.HideBankCards: return IconHideBankCards

            case LobbyImage.StoreItemExpansionClassic56P: return IconStoreItemExpansionClassic56P
            case LobbyImage.StoreItemExpansionClassic78P: return IconStoreItemExpansionClassic78P
            case LobbyImage.StoreItemSeafarers4P: return IconStoreItemSeafarers4P
            case LobbyImage.StoreItemSeafarers56P: return IconStoreItemSeafarers56P
            case LobbyImage.StoreItemCitiesAndKnights4P: return IconStoreItemCitiesAndKnights4P
            case LobbyImage.StoreItemCitiesAndKnights56P: return IconStoreItemCitiesAndKnights56P
            case LobbyImage.StoreItemCitiesAndKnightsSeafarers4P: return IconStoreItemCitiesAndKnightsSeafarers4P
            case LobbyImage.StoreItemCitiesAndKnightsSeafarers56P: return IconStoreItemCitiesAndKnightsSeafarers56P

            case LobbyImage.StoreColorBlack: return IconStoreColorBlack
            case LobbyImage.StoreColorPurple: return IconStoreColorPurple
            case LobbyImage.StoreColorMysticBlue: return IconStoreColorMysticBlue
            case LobbyImage.StoreColorWhite: return IconStoreColorWhite
            case LobbyImage.StoreColorBronze: return IconStoreColorBronze
            case LobbyImage.StoreColorSilver: return IconStoreColorSilver
            case LobbyImage.StoreColorGold: return IconStoreColorGold
            case LobbyImage.StoreColorPink: return IconStoreColorPink

            case LobbyImage.IconSettlerHat: return IconIconSettlerHat
            case LobbyImage.IconColonistHat: return IconIconColonistHat
            case LobbyImage.IconFounderHat: return IconIconFounderHat
            case LobbyImage.IconChristmasHat: return IconIconChristmasHat
            case LobbyImage.IconRobberSanta: return IconIconRobberSanta
            case LobbyImage.IconRobberLunar: return IconIconRobberLunar
            case LobbyImage.IconRobberCupid: return IconIconRobberCupid
            case LobbyImage.IconPirateShip: return IconIconPirateShip
            case LobbyImage.IconMedalGold: return IconIconMedalGold
            case LobbyImage.IconMedalSilver: return IconIconMedalSilver
            case LobbyImage.IconMedalBronze: return IconIconMedalBronze

            case LobbyImage.IconElephant: return IconIconElephant
            case LobbyImage.IconSombrero: return IconIconSombrero
            case LobbyImage.IconFarmer: return IconIconFarmer
            case LobbyImage.IconAvocado: return IconIconAvocado
            case LobbyImage.IconCactus: return IconIconCactus
            case LobbyImage.IconCrown: return IconIconCrown
            case LobbyImage.IconSwords: return IconIconSwords
            case LobbyImage.IconHelmet: return IconIconHelmet
            case LobbyImage.IconSnorkel: return IconIconSnorkel
            case LobbyImage.IconScarf: return IconIconScarf
            case LobbyImage.IconTie: return IconIconTie
            case LobbyImage.IconWorker: return IconIconWorker
            case LobbyImage.IconMummy: return IconIconMummy
            case LobbyImage.IconGifter: return IconIconGifter
            case LobbyImage.IconNoTroll: return IconIconNoTroll
            case LobbyImage.IconRotation: return IconIconRotation
            case LobbyImage.IconTimeBomb: return IconIconTimeBomb
            case LobbyImage.IconBeta: return IconIconBeta

            case LobbyImage.RoadRed: return IconRoadRed
            case LobbyImage.RoadBlue: return IconRoadBlue
            case LobbyImage.RoadGreen: return IconRoadGreen
            case LobbyImage.RoadOrange: return IconRoadOrange
            case LobbyImage.RoadBlack: return IconRoadBlack
            case LobbyImage.RoadSilver: return IconRoadSilver
            case LobbyImage.RoadGold: return IconRoadGold
            case LobbyImage.RoadWhite: return IconRoadWhite
            case LobbyImage.RoadPurple: return IconRoadPurple
            case LobbyImage.RoadMysticBlue: return IconRoadMysticBlue
            case LobbyImage.RoadPink: return IconRoadPink

            case LobbyImage.SettlementRed: return IconSettlementRed
            case LobbyImage.SettlementBlue: return IconSettlementBlue
            case LobbyImage.SettlementGreen: return IconSettlementGreen
            case LobbyImage.SettlementOrange: return IconSettlementOrange
            case LobbyImage.SettlementBlack: return IconSettlementBlack
            case LobbyImage.SettlementSilver: return IconSettlementSilver
            case LobbyImage.SettlementGold: return IconSettlementGold
            case LobbyImage.SettlementWhite: return IconSettlementWhite
            case LobbyImage.SettlementPurple: return IconSettlementPurple
            case LobbyImage.SettlementMysticBlue: return IconSettlementMysticBlue
            case LobbyImage.SettlementPink: return IconSettlementPink

            case LobbyImage.CityRed: return IconCityRed
            case LobbyImage.CityBlue: return IconCityBlue
            case LobbyImage.CityGreen: return IconCityGreen
            case LobbyImage.CityOrange: return IconCityOrange
            case LobbyImage.CityBlack: return IconCityBlack
            case LobbyImage.CitySilver: return IconCitySilver
            case LobbyImage.CityGold: return IconCityGold
            case LobbyImage.CityWhite: return IconCityWhite
            case LobbyImage.CityPurple: return IconCityPurple
            case LobbyImage.CityMysticBlue: return IconCityMysticBlue
            case LobbyImage.CityPink: return IconCityPink

            case LobbyImage.StoreMembershipPlus: return IconStoreMembershipPlus
            case LobbyImage.StoreMembershipPremium: return IconStoreMembershipPremium
            case LobbyImage.StoreMembershipElite: return IconStoreMembershipElite
            case LobbyImage.StoreMembershipHoliday2023: return IconStoreMembershipHoliday2023
            case LobbyImage.StoreGiftMembership: return IconStoreGiftMembership
            case LobbyImage.StoreGiftMembershipDark: return IconStoreGiftMembershipDark

            case LobbyImage.StoreMembershipPerkAllMaps: return IconStoreMembershipPerkAllMaps
            case LobbyImage.StoreMembershipPerkAllExpansions: return IconStoreMembershipPerkAllExpansions
            case LobbyImage.StoreMembershipPerkRankedGames: return IconStoreMembershipPerkRankedGames
            case LobbyImage.StoreMembershipPerkCustomLinks: return IconStoreMembershipPerkCustomLinks
            case LobbyImage.StoreMembershipPerkColonistCoins: return IconStoreMembershipPerkColonistCoins
            case LobbyImage.StoreMembershipPerkNoAds: return IconStoreMembershipPerkNoAds
            case LobbyImage.StoreMembershipPerkNoAdsGifDesertBox: return IconStoreMembershipPerkNoAdsGifDesertBox
            case LobbyImage.StoreMembershipPerkNoAdsGifGoldBox: return IconStoreMembershipPerkNoAdsGifGoldBox
            case LobbyImage.StoreMembershipPerkNoAdsGifDesertHex: return IconStoreMembershipPerkNoAdsGifDesertHex
            case LobbyImage.StoreMembershipPerkNoAdsGifGoldHex: return IconStoreMembershipPerkNoAdsGifGoldHex
            case LobbyImage.StoreMembershipPerkAllColors: return IconAllColors

            case LobbyImage.CoinStack1: return IconCoinStack1
            case LobbyImage.CoinStack2: return IconCoinStack2
            case LobbyImage.CoinStack3: return IconCoinStack3
            case LobbyImage.CoinStack4: return IconCoinStack4
            case LobbyImage.CoinStack5: return IconCoinStack5
            case LobbyImage.CoinStack6: return IconCoinStack6

            case LobbyImage.Friends: return IconFriends
            case LobbyImage.AddFriend: return IconAddFriend

            case LobbyImage.GoogleIcon: return IconGoogleIcon
            case LobbyImage.AppleIcon: return IconAppleIcon
            case LobbyImage.DiscordIcon: return IconDiscordIcon
            case LobbyImage.FacebookIcon: return IconFacebookIcon

            case LobbyImage.RankBronze: return IconRankBronze
            case LobbyImage.RankSilver: return IconRankSilver
            case LobbyImage.RankGold: return IconRankGold
            case LobbyImage.RankPlatinum: return IconRankPlatinum
            case LobbyImage.RankDiamond: return IconRankDiamond
            case LobbyImage.RankMaster: return IconRankMaster
            case LobbyImage.RankGrandmaster: return IconRankGrandmaster

            case LobbyImage.RankSubdivisionI: return IconRankSubdivisionI
            case LobbyImage.RankSubdivisionII: return IconRankSubdivisionII
            case LobbyImage.RankSubdivisionIII: return IconRankSubdivisionIII
            case LobbyImage.RankSubdivisionIV: return IconRankSubdivisionIV
            case LobbyImage.RankSubdivisionV: return IconRankSubdivisionV
            case LobbyImage.LandscapeIcon: return IconMenuLandscapeMode
            case LobbyImage.PortraitIcon: return IconMenuPortraitMode

            case LobbyImage.RewindToStart: return IconRewindToStart
            case LobbyImage.Rewind: return IconRewind
            case LobbyImage.Play: return IconPlay
            case LobbyImage.Pause: return IconPause
            case LobbyImage.FastForward: return IconFastForward
            case LobbyImage.FastForwardToEnd: return IconFastForwardToEnd

            case LobbyImage.X05: return IconX05
            case LobbyImage.X1: return IconX1
            case LobbyImage.X2: return IconX2
            case LobbyImage.X4: return IconX4
            case LobbyImage.X8: return IconX8

            case LobbyImage.DownArrowBlack: return IconDownArrowBlack
            case LobbyImage.DownArrow: return IconDownArrow
            case LobbyImage.UpArrow: return IconUpArrow

            case LobbyImage.LongestRoad: return IconLongestRoad
            case LobbyImage.LargestArmy: return IconLargestArmy
            case LobbyImage.CardMonopoly: return IconCardMonopoly
            case LobbyImage.CardVictoryPoint: return IconCardVictoryPoint

            case LobbyImage.ProfileOverview: return IconProfileOverview
            case LobbyImage.ProfileRanked: return IconProfileRanked
            case LobbyImage.ProfileHistory: return IconProfileHistory
            case LobbyImage.ProfileItems: return IconProfileItems
            case LobbyImage.ProfileMemberships: return IconProfileMembership
            case LobbyImage.ProfileSettings: return IconSettings

            case LobbyImage.TournamentCC25: return IconTournamentCC25
            case LobbyImage.TournamentS11First: return IconTournamentS11First
            case LobbyImage.Tournament4P: return IconTournament4P

            case LobbyImage.BannerMember: return IconBannerMember
            case LobbyImage.BannerShuffle: return IconBannerShuffle
            case LobbyImage.LandscapeDeprecationWarning: return IconLandscapeDeprecationWarning
            case LobbyImage.Leaderboard: return IconLeaderboard
        }
    }
}
